import React from 'react';
import Breadcrumbs from "../../../components/Breadcrumbs/Breadcrumbs";
import ContentPanel from "../../../components/ContentPanel/ContentPanel";
import Skeleton from "../../../components/Skeleton/Skeleton";
import store from "../../../store";
import {Helmet} from "react-helmet";

const contentRestrictions = () => {
  return (
    <div className="wrapper pb36">
        <Helmet>
            {
                store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                    return row.rowTitle === "Ship" ? row.sections.map((section) => {
                        return section.title === "Guidelines & Tools" ? section.subsections.map((subsection) => {
                                    return subsection.title === "Content Restrictions" ? <meta name="description" content={subsection.content['seo-description']}/> : null
                                })
                                : null
                    }) : null
                }) : null
            }
        </Helmet>
      <Breadcrumbs/>
      <ContentPanel
        skeleton={<Skeleton type="MAIN_PANEL"/>}
        errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
        templateUrl="./content/ship/page-components/text-block/content-restrictions-heading.html"
      />
      <div className="fg mtm">
        <div
          className="fg__col-lg-4 fg__col-md-6 fg__col-sm-12">
          <div className="square-image">
            <img className="square-image__image" src="./assets/icons/fire.svg" alt=""/>
            <p className="square-image__text">Shipments likely to damage
              aircraft or other shipments</p>
          </div>
        </div>
        <div
          className="fg__col-lg-4 fg__col-md-6 fg__col-sm-12">
          <div className="square-image">
            <img className="square-image__image" src="./assets/icons/warm-blooded-animal.svg" alt=""/>
            <p className="square-image__text">Live, warm blooded animals</p>
          </div>
        </div>
        <div
          className="fg__col-lg-4 fg__col-md-6 fg__col-sm-12">
          <div className="square-image">
            <img className="square-image__image" src="./assets/icons/venomous-animals.svg" alt=""/>
            <p className="square-image__text">Poisonous or venomous live animals</p>
          </div>
        </div>
        <div
          className="fg__col-lg-4 fg__col-md-6 fg__col-sm-12">
          <div className="square-image">
            <img className="square-image__image" src="./assets/icons/money-or-currency.svg" alt=""/>
            <p className="square-image__text">Money or currency of any kind</p>
          </div>
        </div>
        <div
          className="fg__col-lg-4 fg__col-md-6 fg__col-sm-12">
          <div className="square-image">
            <img className="square-image__image" src="./assets/icons/jewelry.svg" alt=""/>
            <p className="square-image__text">Precious metals or jewelry (other than costume jewelry)</p>
          </div>
        </div>
        <div
          className="fg__col-lg-4 fg__col-md-6 fg__col-sm-12">
          <div className="square-image">
            <img className="square-image__image" src="./assets/icons/furs-closing.svg" alt=""/>
            <p className="square-image__text">Furs and any clothing with fur on it. </p>
          </div>
        </div>
        <div
          className="fg__col-lg-4 fg__col-md-6 fg__col-sm-12">
          <div className="square-image">
            <img className="square-image__image" src="./assets/icons/hazard.svg" alt=""/>
            <p className="square-image__text">Hazardous material</p>
          </div>
        </div>
        <div
          className="fg__col-lg-4 fg__col-md-6 fg__col-sm-12">
          <div className="square-image">
            <img className="square-image__image" src="./assets/icons/firearms.svg" alt=""/>
            <p className="square-image__text">Firearms</p>
          </div>
        </div>
        <div
          className="fg__col-lg-4 fg__col-md-6 fg__col-sm-12">
          <div className="square-image">
            <img className="square-image__image" src="./assets/icons/not-suitable-shipments.svg" alt=""/>
            <p className="square-image__text">Shipments not suitable for carriage</p>
          </div>
        </div>
      </div>
      <p className="pbm">To view a complete list of items not accepted for shipment please view the <a target="_blank" rel="noopener noreferrer" href="./content/home/assets/pdfs/Approved_CargoContractofCarriage.pdf">Southwest
        Cargo Contract of Carriage</a>.</p>
      <ContentPanel
        skeleton={<Skeleton type="MAIN_PANEL"/>}
        errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
        templateUrl="./content/ship/page-components/text-block/content-restrictions-body-1.html"
      />
    </div>
  )
};

export default contentRestrictions;



// WEBPACK FOOTER //
// ./src/pages/ship/GuidelinesAndTools/ContentRestrictions.js